
import React from 'react';
import { Input } from '../../../../components/ui/input';

interface SimpleTitleFieldProps {
	label: string;
	description?: string;
	onChange: (label: string) => void;
	onDescriptionChange: (description: string) => void;
}

const SimpleTitleField: React.FC<SimpleTitleFieldProps> = ({
	label,
	description,
	onChange,
	onDescriptionChange,
}) => {
	return (
		<div className="space-y-2">
			<Input
				value={label}
				onChange={(e) => onChange(e.target.value)}
				className="font-semibold text-lg"
				placeholder="Titel eingeben"
			/>
			<Input
				value={description || ''}
				onChange={(e) => onDescriptionChange(e.target.value)}
				className="text-sm"
				placeholder="Untertitel (optional)"
			/>
		</div>
	);
};

export default SimpleTitleField;
